/**
 * Created by DSadler on 02/05/2017.
 */

/*let template = {
  templateId: "",
  templateName: "",
  templateCategory: "",
  templateContent: "",
  builtIn: "",
};*/

export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const SET_TEMPLATES = "SET_TEMPLATES";

export function createTemplate(id, name, templateCategory, content) {
  return {
    type: CREATE_TEMPLATE,
    id,
    name,
    templateCategory,
    content,
  }
}

export function updateTemplate(templateItem) {
  return {
    type: UPDATE_TEMPLATE,
    templateItem,
  }
}

export function deleteTemplate(templateId) {
  return {
    type: DELETE_TEMPLATE,
    templateId,
  }
}

export function setTemplates(templates) {
  return {
    type: SET_TEMPLATES,
    templates,
  }
}


// WEBPACK FOOTER //
// ./src/App/state/templates/actions.js